<template>
  <main>
    <div class="o-container">
      <section class="age-verification">
        <article  class="o-flex o-flex--justify">
          <div >
            <h1>{{ $t('age_verification.action.heading')}}</h1>
            <p>{{ themeT('age_verification.action.explanation')}}</p>
            <a  class="button button--primary" :href="verificationLink" target="_blank" @click="linkClicked = true"
               v-if="verificationStatus === 'NotStarted' && !linkClicked">{{ $t('age_verification.action.button_link')}}</a>
            <button v-if="verificationStatus === 'Rejected' && verificationAttempts !== 0" class="button button--primary" @click="makeReinitializeSession" :disabled="reinitializing">
              {{ $t('age_verification.action.button_try_again')}} {{reinitializing ? '...' : ''}}
            </button>

            <p v-if="InArray(verificationStatus, ['NotStarted']) && !linkClicked" class="mt mb0"><i>{{ $t('age_verification.action.opens_in')}}</i></p>
          </div>
          <div class="status">
            <ul>
              <li v-if="verificationStatus === 'NotStarted' && !linkClicked">
                <div class="circle circle--not-started"></div>
                <p class="mb0"><strong>{{$t('age_verification.statuses.not_started.heading')}}</strong> {{$t('age_verification.statuses.not_started.text')}}</p>
              </li>
              <li v-if="verificationStatus === 'InProgress' || linkClicked">
                <div class="circle circle--in-progress"></div>
                <p class="mb0"><strong>{{$t('age_verification.statuses.in_progress.heading')}}</strong> {{$t('age_verification.statuses.in_progress.text')}}</p>
              </li>
              <li v-if="verificationStatus === 'Completed'">
                <div class="circle circle--verified"></div>
                <p class="mb0"><strong>{{$t('age_verification.statuses.verified.heading')}}</strong> {{$t('age_verification.statuses.verified.text')}}</p>
              </li>
              <li v-if="verificationStatus === 'Rejected'">
                <div class="circle circle--failed"></div>
                <p class="mb0"><strong>{{$t('age_verification.statuses.failed.heading')}}</strong> {{$t('age_verification.statuses.failed.text')}}</p>
              </li>
            </ul>
          </div>
        </article>
        <div class="how-it-works">
          <h2><strong>How it works</strong></h2>
          <ul class="icons-list">
            <li>
              <div class="icon-wrap">
                <svg fill="none" width="40" viewBox="0 -0.5 25 25">
                  <path fill="#B89450" d="M11.18 7.68a.75.75 0 0 0 1.06 1.06zm2.8-1.74.54.53zm4.55 0-.53.53zm0 4.55L18 9.95zm-2.8 1.74a.75.75 0 1 0 1.06 1.06zm-1.97 4.09a.75.75 0 1 0-1.06-1.06zm-2.8 1.74.52.54v-.01zm-4.52-.03-.53.53zm-.03-4.51-.53-.53zm2.8-1.75a.75.75 0 1 0-1.06-1.06zm6.06-1.51a.75.75 0 1 0-1.06-1.06zm-5.6 3.48a.75.75 0 1 0 1.06 1.06zm2.57-5 2.28-2.27-1.07-1.06-2.27 2.27zm2.28-2.27a2.46 2.46 0 0 1 3.48 0l1.06-1.06a3.96 3.96 0 0 0-5.6 0zm3.48 0c.96.96.96 2.52 0 3.48l1.06 1.07a3.96 3.96 0 0 0 0-5.6zm0 3.48-2.27 2.28 1.06 1.06 2.27-2.27zm-5.3 5.3-2.27 2.28 1.06 1.06 2.27-2.27zm-2.27 2.27c-.96.94-2.5.93-3.46-.02l-1.06 1.06a3.96 3.96 0 0 0 5.57.04zm-3.46-.02a2.46 2.46 0 0 1-.02-3.46l-1.08-1.05a3.96 3.96 0 0 0 .04 5.57zm-.03-3.45 2.27-2.28-1.06-1.06L5.88 13zm7.27-4.85-4.54 4.54 1.06 1.06 4.54-4.54z"/>
                </svg>
              </div>
              <p class="mb0">{{$t('age_verification.how_it_works.first_step')}}</p>
            </li>
            <li>
              <div class="icon-wrap">
                <svg fill="none" width="30" viewBox="0 0 24 24">
                  <path fill="#B89450" fill-rule="evenodd" d="M12 18a5 5 0 1 0 0-10 5 5 0 0 0 0 10m0-2a3 3 0 1 1 0-6 3 3 0 0 1 0 6" clip-rule="evenodd"/>
                  <path fill="#B89450" fill-rule="evenodd" d="M9.56 2a3 3 0 0 0-2.9 2.27L6.21 6H4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3h-2.22l-.43-1.73A3 3 0 0 0 14.44 2zM8.6 4.76A1 1 0 0 1 9.56 4h4.88a1 1 0 0 1 .97.76l.43 1.73A2 2 0 0 0 17.78 8H20a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2.22a2 2 0 0 0 1.94-1.51z" clip-rule="evenodd"/>
                </svg>
              </div>
              <p class="mb0">{{$t('age_verification.how_it_works.second_step')}}</p>
            </li>
            <li>
              <div class="icon-wrap">
                <svg fill="none"  width="30" viewBox="0 0 24 24">
                  <path stroke="#B89450" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.3 21.61c.22.13.33.2.49.23.12.03.3.03.42 0 .16-.03.27-.1.49-.23 1.95-1.13 7.3-4.7 7.3-9.61V6.6c0-.56 0-.84-.1-1.05a1 1 0 0 0-.44-.44c-.21-.1-.5-.1-1.06-.12C15.43 4.96 13.7 4.71 12 3c-1.71 1.71-3.43 1.96-6.4 2-.57 0-.85 0-1.06.11a1 1 0 0 0-.43.44C4 5.76 4 6.05 4 6.6V12c0 4.9 5.35 8.48 7.3 9.61"/>
                </svg>
              </div>
              <p class="mb0">{{$t('age_verification.how_it_works.third_step')}}</p>
            </li>
          </ul>

          <p>{{themeT('age_verification.how_it_works.resume')}}</p>

          <div class="divider"></div>
          <h2 class="mb"><strong>{{$t('age_verification.important.heading')}}</strong></h2>

          <ul class="mb+">
            <li><p class="mb-">{{$t('age_verification.important.first')}}</p></li>
            <li><p class="mb-">{{$t('age_verification.important.second')}}</p></li>
            <li><p class="mb0">{{$t('age_verification.important.third')}}</p></li>
          </ul>

          <p>{{$t('age_verification.important.support')}} <a :href="'mailto:'+email">{{email}}</a></p>
        </div>

      </section>
    </div>
  </main>
</template>
<script>

import {mapState} from "vuex";
import {ageVerificationUpdated, connect} from "@/connection/websocket/connection";
import {ageVerificationStatusChangedListener} from "@/connection/websocket/listeners";
import {reinitialize} from "@/service/age-verification";
import InArray from "@/service/helpers/InArray";
import ThemeMixin from "@/mixins/ThemeMixin";
import { supportEmail } from "@/service/support-email";

export default {
  mixins: [ThemeMixin],
  data(){
    return {
      linkClicked: false,
      reinitializing: false,
      email: supportEmail(),
    }
  },
  computed: {
    ...mapState({
      verificationLink: state => state.ageVerification.verificationLink,
      verificationStatus: state => state.ageVerification.verificationStatus,
      verificationAttempts: state => state.ageVerification.verificationAttempts
    })
  },
  beforeMount() {
    connect().then(connection => {
      ageVerificationUpdated(connection).listen('.age.verification.status.changed', ageVerificationStatusChangedListener)
    }).finally(() => {
      this.linkClicked = false
    })
  },
  methods: {
    InArray,
    makeReinitializeSession(){
      this.linkClicked = false
      this.reinitializing = true
      reinitialize().finally(() => {
        this.reinitializing = false
      })
    }
  },
}
</script>


<style scoped lang="scss">
  main {
    height: auto;

    @media (max-width: 991px) {
      background-color: #fff;
    }
  }

  .age-verification {
    padding: 60px 100px;
    border-radius: 10px;
    background-color: #fff;
    min-height: calc(100% - 40px);
    height: auto;
    overflow: hidden;

    @media (max-width: 991px) {
      padding: 20px 0 100px;
      margin-top: 0;
    }

    h1 {
      font-weight: 700;
    }

    p {
      line-height: 1.3;
    }

    article {
      gap: 100px;

      @media (max-width: 768px) {
        gap: 50px;
        flex-direction: column;
      }
    }

    .status {
      padding: 20px;
      background-color: #f5f5f5;
      border-radius: 20px;
      border: 1px solid #B89450;

      ul {
        display: flex;
        flex-direction: column;
        gap: 10px;
      }

      li {
        display: flex;
        gap: 20px;

        .circle {
          width: 20px;
          min-width: 20px;
          height: 20px;
          border-radius: 50%;
          // border: 2px solid #bababa;

          &--not-started {
            background-color: #bababa;
            
            &.active {
              box-shadow: 0 0 0 5px rgba(#bababa, .4);
              & + p strong {
                color: #bababa;
              }
            }
          }

          &--in-progress {
            background-color: #1587FB;
            
            &.active {
              box-shadow: 0 0 0 5px rgba(#1587FB, .4);
              & + p strong {
                color: #1587FB;
              }
            }     
          }

          &--pending-review {
            background-color: $color-type35;
            
            &.active {
              box-shadow: 0 0 0 5px rgba($color-type35, .4);
              & + p strong {
                color: $color-type35;
              }
            }           
          }

          &--verified {
            background-color: $color-type25;
            
            &.active {
              box-shadow: 0 0 0 5px rgba($color-type25, .4);
              & + p strong {
                color: $color-type25;
              }
            }     
          }

          &--failed {
            background-color: $color-type24;
            
            &.active {
              box-shadow: 0 0 0 5px rgba($color-type24, .4);
              & + p strong {
                color: $color-type24;
              }
            }     
          }
        }

        p {
          font-size: 14px;
        }
      }
    }

    .how-it-works {
      margin-top: 60px;

      h2 {
        margin-bottom: 40px;
      }

      ul.icons-list {
        display: flex;
        align-items: center;
        gap: 20px;
        margin-bottom: 40px;
        
        li {
          display: flex;
          align-items: center;
          gap: 15px;
        }
      }


      .icon-wrap {
        width: 60px;
        min-width: 60px;
        height: 60px;
        border-radius: 50%;
        border: 2px solid $color-type19;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      @media (max-width: 768px) {
        ul.icons-list {
          flex-direction: column;
          align-items: flex-start;
        }
      }
    }

    .divider {
      width: 100%;
      margin: 0 auto 20px;
      background-color: #DEDEDE;
      height: 1px;
    }
  }
</style>
